import IRepository from "./repository";

const GETTER_GET_SESSION = 'getSession';
const GETTER_GET_VALID = 'getValid';

const ACTION_WAIT_FOR_SESSION = 'waitForSession';
const ACTION_SET_TOKEN = 'setToken';
const ACTION_REMOVE_SESSION = 'removeSession';

export default class SessionRepository extends IRepository {
    /**
     * Get current Session
     * @returns {Session}
     */
    getSession() {
        return this.getters(GETTER_GET_SESSION);
    }

    /**
     * Check if current session is valid
     * @returns {boolean}
     */
    getValid() {
        return this.getters(GETTER_GET_VALID);
    }

    /**
     * Wait for session ready
     * @returns {Promise<void>}
     */
    async waitForSession() {
        await this.dispatch(ACTION_WAIT_FOR_SESSION);
    }

    /**
     * Set current session token. Return true if valid token.
     * @param token {string}
     * @returns {Promise<boolean>}
     */
    async setToken(token) {
        await this.waitForSession();
        return await this.dispatch(ACTION_SET_TOKEN, token);
    }

    /**
     * Remove current session
     * @returns {Promise<void>}
     */
    async removeSession() {
        await this.waitForSession();
        return await this.dispatch(ACTION_REMOVE_SESSION);
    }
}